import { useId } from "react";

interface GradientSpinnerProps {
  size?: number;
  className?: string;
}

export function GradientSpinner({
  size = 24,
  className,
}: GradientSpinnerProps) {
  const gradientId = useId();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={`motion-safe:animate-spin${className ? ` ${className}` : ""}`}
      aria-hidden="true"
    >
      <path
        d="M8 0L9.5 6.5L16 8L9.5 9.5L8 16L6.5 9.5L0 8L6.5 6.5L8 0Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="16" y2="16">
          <stop stopColor="#FF3072" />
          <stop offset="1" stopColor="#750087" />
        </linearGradient>
      </defs>
    </svg>
  );
}
